export class UserRestriction
{
    allModels: boolean;
    summary: boolean;
    subscribed: boolean;
}